<div class="row justify-content-center">
  <div class="col-7">
    <form #messageForm="ngForm" (ngSubmit)="submitReply()" novalidate>

      <div class="box">
        <h2>Message</h2>
        <div class="messageContainer">
          <div class="message">
            <p [innerHtml]="model.content"></p>
          </div>
          <div *ngFor="let attachment of model.nonDeletedAttachments">
            <a (click)="downloadAttachment(attachment)">{{attachment.name}}</a>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <div class="form-group">
              <label for="comment">Add Comment</label>
              <ckeditor name="message" required [config]="editorConfig" [editor]="Editor" [(ngModel)]="reply.content" [disabled]="messageSent"></ckeditor>
              <app-attachments [(attachments)]="reply.attachments" [supportedFileTypes]="supportedFileTypes" [maxFileSize]="maxFileSize" [maxCumulativeFileSize]="maxCumulativeFileSize" [saveRoute]="saveAttachmentRoute" [isRequired]="false"></app-attachments>
              <button type="submit" [disabled]="isProcessing || !messageForm.form.valid" class="btn btn-primary mx-0 mt-1">
                <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="isProcessing"></i> Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div mdbModal #thankYouModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="thankYouModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Thank you</h4>
      </div>
      <div class="modal-body">Your response to this message has already been received.</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" aria-label="Close" (click)="thankYouModal.hide()" mdbWavesEffect>Ok</button>
      </div>
    </div>
  </div>
</div>
